import { useUiLocale } from './context';
import { isUiLanguage } from './instance';
import {
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuSeparator,
} from 'components/ui/dropdown-menu';

export const LanguageMenuItems = () => {
    const { language, setLanguage } = useUiLocale();
    if (!setLanguage) return null;
    return (
        <>
            <DropdownMenuLabel>Language / Bahasa</DropdownMenuLabel>
            <DropdownMenuRadioGroup
                value={language}
                onValueChange={(next) => {
                    if (isUiLanguage(next)) setLanguage(next);
                }}
                aria-label="Language / Bahasa"
            >
                <DropdownMenuRadioItem value="en" lang="en">
                    English
                </DropdownMenuRadioItem>
                <DropdownMenuRadioItem value="id" lang="id">
                    Bahasa Indonesia
                </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
            <DropdownMenuSeparator />
        </>
    );
};

export const LanguageSelector = () => {
    const { language, setLanguage } = useUiLocale();
    if (!setLanguage) return null;
    return (
        <select
            aria-label="Language / Bahasa"
            className="h-8 max-w-44 rounded-md border bg-background px-2 text-sm text-foreground"
            value={language}
            onChange={(event) => {
                if (isUiLanguage(event.target.value))
                    setLanguage(event.target.value);
            }}
        >
            <option value="en" lang="en">
                English
            </option>
            <option value="id" lang="id">
                Bahasa Indonesia
            </option>
        </select>
    );
};
